import React, { useEffect, useRef } from 'react'

import { ChatMessage, ChatMessageItemType } from './ChatMessageItem'

type ChatMessagesType = {
  messages: ChatMessage[]
}
export const ChatMessages: React.FC<ChatMessagesType> = ({ messages }) => {
  return (
    <>
      {messages.map((m: ChatMessage, idx: number) => (
        <ChatMessageItemType item={m} key={idx} />
      ))}

      <ScrollToBottom />
    </>
  )
}

const ScrollToBottom = () => {
  const elementRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    elementRef?.current && elementRef.current.scrollIntoView()
  }, [])
  return <div ref={elementRef} />
}
